<template>
    <views class="home">
        <banner :list="bannerList" :padding="false" :radius="false"></banner>
        <!-- <views class="search">
            <views class="search-inner">
                <views class="icon">
                    <images :src="searchIcon"></images>
                </views>
                <views class="name" @click="handleSearch">搜索农业知识库内容</views>
                <views class="code" @click="handleSearch">
                    <images :src="codeIcon"></images>
                </views>
            </views>
        </views> -->
        <views class="menu">
            <views
                v-for="item in menuList"
                :key="item.name"
                class="menu-list"
                @click="handleUrl(item)">
                <views class="menu-icon">
                    <images :src="item.icon"></images>
                </views>
                <views class="menu-name">{{ item.name }}</views>
            </views>
        </views>
        <views class="prize-box">
            <views class="prize-banner" @click="handlePrize">
                <images :src="prizeBanner"></images>
            </views>
            <gift-list v-if="giftList.length > 0" :list="giftList"></gift-list>
        </views>
        <views class="line"></views>
        <!-- <views class="search">
            <views class="search-inner">
                <views class="icon">
                    <images :src="searchIcon"></images>
                </views>
                <views class="name" @click="handleSearch">搜索农业知识库内容</views>
                <views class="code" @click="handleSearch">
                    <images :src="codeIcon"></images>
                </views>
            </views>
        </views> -->
        <views class="article">
            <views class="article-title">
                <views class="name">资讯中心</views>
                <views class="more" @click="handleMore">
                    更多
                    <images :src="moreIcon"></images>
                </views>
            </views>
            <views class="article-content">
                <article-item
                    v-for="item in articleList"
                    :key="item.id"
                    :item="item"
                    only-title
                    @click="handleDetail">
                </article-item>
            </views>
        </views>
        <views class="line"></views>
        <views class="other">
            <views class="other-title">
                <views class="name">其他</views>
            </views>
            <views class="other-content">
                <views
                    v-for="(item, index) in otherList"
                    :key="item.title"
                    class="other-item"
                    @click="handleUrl(item)">
                    <views
                        :class="`bg${index + 1}`"
                        class="other-item-con">
                        <views class="name">{{ item.title }}</views>
                        <views class="des">{{ item.subTitle }}</views>
                        <views class="icon">
                            <images :src="item.icon"></images>
                        </views>
                    </views>
                </views>
            </views>
        </views>
        <views class="line"></views>
        <views
            v-if="showWechat"
            class="show-wechat"
            @click="closeWechat">
            <images :src="wechatImg"></images>
        </views>
        <full-screen-ad
            v-if="showAd"
            v-model="showAd"
            :data="flashData">
        </full-screen-ad>
    </views>
</template>

<script>
import Banner from '@/components/banner'
import ArticleItem from '@/components/articleItem'
import FullScreenAd from '@/components/fullScreenAd'
import GiftList from './GiftList'
import tools from '@/mixins/tools'
import api from '@/utils/api'
import storage from '@/utils/storage'
import wx from 'weixin-jsapi'
import getLocation from '@/mixins/getLocation'
export default {
    name: 'Home',
    components: {
        Banner,
        ArticleItem,
        FullScreenAd,
        GiftList
    },
    mixins: [tools, getLocation],
    data() {
        return {
            hasLucky: false,
            showAd: false,
            showWechat: false,
            searchIcon: require('@/assets/images/sy_ss@3x.png'),
            codeIcon: require('@/assets/images/sy_search.png'),
            moreIcon: require('@/assets/images/awr.png'),
            wechatImg: require('@/assets/images/wechat.png'),
            bannerList: [],
            prizeBannerList: [],
            articleList: [],
            flashData: {},
            giftList: [],
            menuList: [
                {
                    name: '防伪查询',
                    icon: require('@/assets/images/sy4.png'),
                    url: 'scanCode'
                },
                {
                    name: '产品中心',
                    icon: require('@/assets/images/sy_cpzx@3x.png'),
                    url: 'https://www.sacf.com/cn/ProductList.aspx?TypeId=10006'
                },
                {
                    name: '资讯中心',
                    icon: require('@/assets/images/sy_njzs@3x.png'),
                    url: '/article'
                },
                {
                    name: '反馈意见',
                    icon: require('@/assets/images/sy_zxwd@3x.png'),
                    // url: '/feedback'
                    url: '/feedbacklist'
                }
            ],
            otherList: [
                {
                    title: '产品中心',
                    subTitle: '优质放心产品',
                    icon: require('@/assets/images/sy_cpzxa@3x.png'),
                    url: 'https://www.sacf.com/cn/ProductList.aspx?TypeId=10006'
                },
                {
                    title: '品牌文化',
                    subTitle: '阳光雨露撒可富',
                    icon: require('@/assets/images/sy_ppwh1@3x.png'),
                    url: 'https://www.sacf.com/cn/NewsList.aspx?TypeId=10016'
                },
                {
                    title: '官微互动',
                    subTitle: '欢迎留言互动',
                    icon: require('@/assets/images/sy_gwhd1@3x.png'),
                    url: 'wechat'
                },
                {
                    title: '农化服务',
                    subTitle: '诚信和谐创新',
                    icon: require('@/assets/images/sy_nhfw1@3x.png'),
                    url: 'https://www.sacf.com/cn/News.aspx?TypeId=10020'
                }
            ]
        }
    },
    beforeMount() {
        // 获取坐标
        wx.ready((e) => {
            console.log('readyreadyreadyreadyreadyready', e)
            this.getLoacationPos().then(res => {
                // this.getLocation().then(res => {
                //     var param = {
                //         public_code: this.$route.query.public_code,
                //         province: res.addressComponent.province,
                //         city: res.addressComponent.city,
                //         district: res.addressComponent.district
                //     }
                //     this.getActivity(param)
                // })
            })
        })
    },
    mounted() {
        // 扫码调整至h5时，会在url上带入明码字段?public_code=****
        if (this.$route.query.public_code) {
            this.$store.commit('setPublicCode', this.$route.query.public_code)
        }
        this.currentState = false
    },
    computed: {
        query() {
            return this.$route.query
        },
        prizeBanner() {
            return this.prizeBannerList[0] && this.prizeBannerList[0].url
        }
    },
    activated() {
        this.init()
        // 扫码进入首页保存-明码
        console.log('进入首页的query', this.query.public_code)
        if (this.query.public_code !== undefined) {
            storage.set('scan_JR_public_code', this.query.public_code)
        }
    },
    methods: {
        init() {
            this.getFlashList()
            this.getBanner()
            this.getPrizeBanner()
            this.getActivity()
            this.getArticle()
        },
        closeWechat() {
            this.showWechat = false
        },
        handleUrl(item) {
            if (item.url === 'wechat') {
                this.showWechat = true
            } else if (item.url === 'scanCode') {
                // this.windowReplace('/scan-code?type=verify&public=1')
                // this.push('/scan-code?type=verify&public=1')
                if (this.$store.getters.getPublicCode) {
                    this.push('/verify?type=verify&public=1')
                } else {
                    this.push('/scan-code?type=verify&public=1')
                }
            } else {
                this.windowPush(item.url)
            }
        },
        getFlashList() {
            api.getFlashList().then((res) => {
                if (res.data.list && res.data.list[0]) {
                    this.flashData = res.data.list[0]
                    // frequency 1：首次显示 2：每次显示
                    if (this.flashData.frequency === 1) {
                        if (!storage.get('isShowFlash')) {
                            storage.set('isShowFlash', true)
                            this.showAd = true
                        }
                    } else {
                        if (this.flashData.frequency === 2 && this.currentState === false) {
                            this.showAd = true
                            this.currentState = true
                        }
                        storage.remove('isShowFlash')
                    }
                }
            })
        },
        getBanner() {
            api.getBanner({ position_type: 1 }).then((res) => {
                console.log('获取banner打印', res)
                if (res.data.list) {
                    this.bannerList = res.data.list
                }
            })
        },
        getPrizeBanner() {
            api.getBanner({ position_type: 2 }).then((res) => {
                if (res.data.list) {
                    this.prizeBannerList = res.data.list
                }
            })
        },
        getActivity(data = {}) {
            console.log(data)
            api.getActivity(data).then((res) => {
                console.log('获取活动打印', res)
                if (res.data) {
                    this.hasLucky = true
                    this.$store.commit('setActive', true)
                    this.getPrizeList(res.data.id)
                    storage.set('prizeObj', JSON.stringify(res.data))
                }
            })
        },
        getPrizeList(id) {
            const params = {
                id,
                page: 1,
                page_size: 10
            }
            api.getPrizeList(params).then((res) => {
                if (res.data.list) {
                    this.giftList = res.data.list
                }
            })
        },
        getArticle() {
            const params = {
                page: 1,
                page_size: 3,
                collected: false
            }
            api.getArticleList(params).then((res) => {
                this.articleList = res.data.list
                console.log(res)
            })
        },
        handleMore() {
            this.push('/article')
        },
        handleDetail(row) {
            this.windowPush(`/article-detail?id=${row.id}&name=农业知识`)
        },
        handleSearch() {
            this.push('/search?from=home&to=article&placeholder=搜索农业知识库内容')
        },
        handlePrize() {
            if (this.hasLucky) {
                this.push('/scan-code?type=prize&public=1')
            } else {
                this.$toast('暂无抽奖活动')
            }
            // this.push('/prize')
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
